/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import superagentPromise from 'superagent-promise';
import superagent from 'superagent';
import get from 'lodash/get';
import { debug } from './utils';
import { isError } from './stores/actionCreator';
import filter from 'lodash/filter';
import map from 'lodash/map';
import profileStore from './stores/profileStore';

const ajax = superagentPromise(superagent, global.Promise);

/**
 * A wrapper around superagent to simplify ajax requests
 */
class Fetch {
    constructor() {
        //you can't define async functions as class properties
        this.get = this.get.bind(this);
        this.post = this.post.bind(this);
        this.put = this.put.bind(this);
        this.patch = this.patch.bind(this);
        this.delete = this.delete.bind(this);
        this.submit = this.submit.bind(this);
    }

    handleError = data => {
        let err;

        if (data.items) {
            let errors = filter(data.items, item => {
                if (item.code && item.info) return true;
                return false;
            });
            if (errors && errors.length > 0) {
                let userMessage = '';
                map(errors[0].info, msg => {
                    userMessage += msg.join(', ');
                });
                return {
                    error: {
                        userMessage,
                        statusCode: errors[0].code,
                    },
                };
            }
        } else if (data.error) {
            err = data.error;
        }

        return {
            error: {
                userMessage:
                    get(err, 'response.statusText') ||
                    get(err, 'message') ||
                    get(err, 'userMessage.original') ||
                    get(err, 'userMessage') ||
                    get(err, 'statusMessage') ||
                    get(err, 'extra.info') ||
                    'Unknown error',
                statusCode:
                    get(err, 'response.statusCode') ||
                    get(err, 'code') ||
                    get(err, 'statusCode') ||
                    'Unknown error code',
            },
        };
    };

    request = (method, url, params, abortCallback) => {
        debug('Fetch request', method, url, params);
        return new Promise((resolve, reject) => {
            ajax[method](url, params, abortCallback)
                .retry(3)
                .on('abort', () => {
                    reject(this.handleError({ message: 'The video upload was canceled' }));
                })
                .then(
                    res => {
                        const data = get(res, 'body.data', get(res, 'body'));
                        if (isError(data)) {
                            resolve(this.handleError(data));
                        } else {
                            resolve(data);
                        }
                    },
                    err => {
                        debug('Error in fetch', err);
                        reject(this.handleError(err));
                    }
                );
        });
    };

    async get({ url = '/', params = {}, abortCallback, disableClientFilter = false } = {}) {
        if (!disableClientFilter && profileStore.client._id)
            params['filterBy-__belong.Client'] = profileStore.client._id;

        return await this.request('get', url, params, abortCallback);
    }

    async post({ url = '/', body = {}, abortCallback } = {}) {
        return await this.request('post', url, body, abortCallback);
    }

    async put({ url = '/', body = {}, abortCallback } = {}) {
        return await this.request('put', url, body, abortCallback);
    }

    async patch({ url = '/', body = {}, abortCallback } = {}) {
        return await this.request('patch', url, body, abortCallback);
    }

    async delete({ url = '/', body = {}, abortCallback } = {}) {
        return await this.request('del', url, body, abortCallback);
    }

    async submit({ form, url, onProgress = false, abortCallback } = {}) {
        debug('Submit request', url);
        return new Promise((resolve, reject) => {
            ajax.post(url, form, abortCallback)
                .on('progress', e => {
                    debug('Percentage done: ', e.percent);
                    if (onProgress) onProgress(e.percent);
                })
                .on('abort', () => {
                    reject(this.handleError({ message: 'The video upload was canceled' }));
                })
                .then(
                    res => {
                        resolve(res);
                    },
                    err => {
                        reject(this.handleError(err));
                    }
                );
        });
    }
}

const fetch = new Fetch();
export default fetch;
